import { useCallback } from "react";
import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana35Div2M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandById = (id) => {
    return lands.filter((l) => l.id === id)[0];
  };
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };
  const getFill = useCallback(
    (id, selected2) => {
      const land = lands.find((l) => l.id === id);
      const disabledColor = "#6F8789";
      const normalColor = "#0096B3";
      const selectedColor = "#5AE5F4";

      if (!land) {
        return disabledColor; // disabled
      }

      if (selected) {
        if (id === selected.id) {
          return selectedColor;
        }
      }

      if (land.status !== "on_sale") {
        return disabledColor; // disabled
      } else {
        return normalColor; // normal color
      }
    },
    [lands, selected]
  );

  if (!lands) {
    return <></>;
  }

  return (
    <svg
      width={style?.width || "1219"}
      height={style?.height || "941"}
      viewBox="0 0 1221 921"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="1221" height="921" fill="url(#pattern0_1468_43834)" />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("14"))}
        d="M297.266 787.498L329.126 723.779L226.051 671.305L194.191 736.898L297.266 787.498Z"
        fill={getFillByLot(14, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("15"))}
        d="M362.851 667.556L329.118 723.778L226.043 671.304L269.147 596.34L362.851 667.556Z"
        fill={getFillByLot(15, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("16"))}
        d="M407.835 609.454L362.857 667.551L269.152 596.336L312.256 536.365L407.835 609.454Z"
        fill={getFillByLot(16, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("17"))}
        d="M450.932 547.613L407.828 609.458L312.25 536.369L355.354 476.398L450.932 547.613Z"
        fill={getFillByLot(17, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("18"))}
        d="M495.927 489.513L450.949 547.61L355.371 476.395L400.349 416.424L495.927 489.513Z"
        fill={getFillByLot(18, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("19"))}
        d="M539.02 429.544L495.916 489.515L400.338 416.425L443.442 358.329L539.02 429.544Z"
        fill={getFillByLot(19, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("20"))}
        d="M583.998 369.572L539.02 429.543L443.441 358.328L488.419 296.483L583.998 369.572Z"
        fill={getFillByLot(20, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("21"))}
        d="M625.216 309.604L583.987 369.575L488.408 296.486L533.386 238.389L625.216 309.604Z"
        fill={getFillByLot(21, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("22"))}
        d="M668.333 251.505L625.229 309.601L533.398 238.386L576.502 178.415L668.333 251.505Z"
        fill={getFillByLot(22, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("23"))}
        d="M687.067 225.267L668.326 251.504L576.496 178.415L647.711 84.7107L687.067 225.267Z"
        fill={getFillByLot(23, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <defs>
        <pattern
          id="pattern0_1468_43834"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            href="#image0_1468_43834"
            transform="matrix(0.0025706 0 0 0.0034072 -3.08874 -1.10486)"
          />
        </pattern>
        <image
          id="image0_1468_43834"
          width="4096"
          height="2304"
          href="/mz2.png"
        />
      </defs>
    </svg>
  );
};
